import {Badge} from "@mantine/core";

// MeteringRecordState two-state (FNP-534): OPEN (still accumulating) / CLOSED
// (immutable, past periodEnd + grace).
export const StatusBadge = ({status}: { status: string }) => {
    let color = 'gray';
    if (status === 'OPEN') {
        color = 'blue';
    } else if (status === 'CLOSED') {
        color = 'green';
    }
    return <Badge color={color}>{status}</Badge>;
};
